/**
 * Define security questions list
 */
export default {
    global: {
        mfaInfo:
            'https://playersupport.nexon.com/hc/articles/360025920992?_ga=2.215824343.1518764146.1587964369-1059947177.1586450844',
        learnMore: {
            authApp: 'https://playersupport.nexon.com/hc/en-us/articles/360025920992',
            sms: 'https://playersupport.nexon.com/hc/en-us/articles/360058955512-SMS-FAQ',
        },
    },
    one: {
        mfaInfo:
            'https://playersupport.nexon.com/hc/articles/360025920992?_ga=2.215824343.1518764146.1587964369-1059947177.1586450844)',
        learnMore: {
            authApp: 'https://playersupport.nexon.com/hc/en-us/articles/360025920992',
            sms: 'https://playersupport.nexon.com/hc/en-us/articles/360058955512-SMS-FAQ',
        },
    },
    th: {
        mfaInfo: 'https://th.nexon.com/forum/th/forum/283/board/663/thread/59973',
        learnMore: {
            authApp: 'https://th.nexon.com/forum/th/forum/283/board/663/thread/59973',
            sms: 'https://playersupport.nexon.com/hc/en-us/articles/360058955512-SMS-FAQ',
        },
    },
    tw: {
        mfaInfo: 'https://tw.nexon.com/forum/zh/forum/264/board/1361/thread/59812',
        learnMore: {
            authApp: 'https://tw.nexon.com/forum/zh/forum/264/board/1361',
            sms: 'https://playersupport.nexon.com/hc/en-us/articles/360058955512-SMS-FAQ',
        },
    },
    sea: {
        mfaInfo:
            'https://playersupport.nexon.com/hc/articles/360025920992?_ga=2.215824343.1518764146.1587964369-1059947177.1586450844)',
        learnMore: {
            authApp: 'https://playersupport.nexon.com/hc/en-us/articles/360025920992',
            sms: 'https://playersupport.nexon.com/hc/en-us/articles/360058955512-SMS-FAQ',
        },
    },
    japan: {
        mfaInfo:
            'https://playersupport.nexon.com/hc/articles/360025920992?_ga=2.215824343.1518764146.1587964369-1059947177.1586450844',
        learnMore: {
            authApp: 'https://playersupport.nexon.com/hc/en-us/articles/360025920992',
            sms: 'https://playersupport.nexon.com/hc/en-us/articles/360058955512-SMS-FAQ',
        },
    },
};
